(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["abbett-wishlist"]) return;
  try {
    
  (() => {
    const root = document.querySelector('.wishlist-luxe');
    if (!root) return;
    const count = root.querySelector('[data-wishlist-count]');
    const grid = root.querySelector('[grid-wishlist]');
    const updateCount = (items) => {
      if (count) count.textContent = String(items.length);
      if (grid) grid.setAttribute('aria-busy', 'false');
    };
    const storedItems = () => {
      const value = localStorage.getItem('shopify-wishlist');
      return value ? value.split(',').filter(Boolean) : [];
    };
    updateCount(storedItems());
    document.addEventListener('shopify-wishlist:updated', (event) => updateCount(event.detail.wishlist || []));
    document.addEventListener('shopify-wishlist:init-product-grid', (event) => updateCount(event.detail.wishlist || []));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-post-alexandrite-guide"]) return;
  try {
    
  (() => {
    const sections = document.querySelectorAll('.alexandrite-guide');

    sections.forEach((section) => {
      const content = section.querySelector('[data-guide-content]');
      const toc = section.querySelector('[data-guide-toc]');
      const tocList = section.querySelector('[data-guide-toc-list]');
      const progress = section.querySelector('.alexandrite-guide__progress span');

      if (content && toc && tocList) {
        const headings = [...content.querySelectorAll('h2')];

        headings.forEach((heading, index) => {
          if (!heading.id) heading.id = `guide-section-${index + 1}`;
          const item = document.createElement('li');
          const link = document.createElement('a');
          link.href = `#${heading.id}`;
          link.textContent = heading.textContent;
          item.appendChild(link);
          tocList.appendChild(item);
        });

        if (headings.length > 1) {
          toc.hidden = false;
          const links = [...tocList.querySelectorAll('a')];
          const observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
              if (!entry.isIntersecting) return;
              links.forEach((link) => link.removeAttribute('aria-current'));
              const active = tocList.querySelector(`a[href="#${entry.target.id}"]`);
              if (active) active.setAttribute('aria-current', 'true');
            });
          }, { rootMargin: '-18% 0px -68% 0px' });
          headings.forEach((heading) => observer.observe(heading));
        }
      }

      if (progress) {
        const updateProgress = () => {
          const rect = section.getBoundingClientRect();
          const available = Math.max(section.offsetHeight - window.innerHeight, 1);
          const value = Math.min(Math.max(-rect.top / available, 0), 1);
          progress.style.transform = `scaleX(${value})`;
        };
        updateProgress();
        window.addEventListener('scroll', updateProgress, { passive: true });
        window.addEventListener('resize', updateProgress);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-information"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', (event) => {
    const tab = event.target.closest('.product-more-info [role="tab"]');
    if (!tab) return;
    const section = tab.closest('.product-more-info');
    section.querySelectorAll('[role="tab"]').forEach((item) => {
      item.setAttribute('aria-selected', item === tab ? 'true' : 'false');
    });
  });

  } catch(e) { console.error(e); }
})();
})();
